import React, { useState, useEffect } from 'react';
import { getTeamsByAgentur, createTeam, deleteATeam, updateTeam } from '../api';
import { useParams, useNavigate } from 'react-router-dom';
import { FaCog, FaTrash } from 'react-icons/fa';
import DashboardNav from '../components/dashboard/DashboardNav';
import TeamDashboard from '../components/dashboard/TeamDashboard';
import { getMyTeamMembers, getTeamLeads } from '../api';

function AgenturTeams({ user }) {
  const { id: agenturId } = useParams();
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [newTeam, setNewTeam] = useState({ name: '', beschreibung: '' });
  const [createError, setCreateError] = useState('');
  const [editDialog, setEditDialog] = useState({ open: false, team: null, name: '', beschreibung: '', error: '' });
  const [deleteDialog, setDeleteDialog] = useState({ open: false, team: null, error: '' });
  const navigate = useNavigate();

  const loadTeams = async () => {
    setLoading(true);
    setError('');
    const data = await getTeamsByAgentur(user.id, agenturId);
    if (data.success) {
      setTeams(data.teams || []);
    } else {
      setError(data.error || 'Fehler beim Laden der Teams.');
    }
    setLoading(false);
  };

  useEffect(() => {
    if (user?.id && agenturId) {
      loadTeams();
    }
    // eslint-disable-next-line
  }, [user?.id, agenturId]);

  const handleCreateTeam = async () => {
    setCreateError('');
    if (!newTeam.name.trim()) {
      setCreateError('Bitte einen Teamnamen angeben.');
      return;
    }

    console.log("UserID : ", user.id)
    console.log("AgenturID : ", agenturId)
    console.log("Name : ", newTeam.name)
    console.log("Beschreibung : ", newTeam.beschreibung)

    const result = await createTeam({
      userId: user.id,
      agenturId: parseInt(agenturId, 10),
      name: newTeam.name,
      beschreibung: newTeam.beschreibung
    });

    if (result.success) {
      setShowCreateDialog(false);
      setNewTeam({ name: '', beschreibung: '' });
      loadTeams();
    } else {
      setCreateError(result.error || 'Fehler beim Erstellen des Teams.');
    }
  };

  const handleEditClick = (team) => {
    setEditDialog({ open: true, team, name: team.name, beschreibung: team.beschreibung || '', error: '' });
  };

  const handleEditSave = async () => {
    if (!editDialog.name.trim()) {
      setEditDialog(d => ({ ...d, error: 'Bitte einen Teamnamen angeben.' }));
      return;
    }
    try {
      const result = await updateTeam(user.id, editDialog.team.id, editDialog.name, editDialog.beschreibung, editDialog.team.active);
      if (result.success) {
        setEditDialog({ open: false, team: null, name: '', beschreibung: '', error: '' });
        loadTeams();
      } else {
        setEditDialog(d => ({ ...d, error: result.error || 'Fehler beim Bearbeiten.' }));
      }
    } catch (err) {
      setEditDialog(d => ({ ...d, error: 'Netzwerkfehler beim Bearbeiten.' }));
    }
  };

  const handleDeleteClick = (team) => {
    setDeleteDialog({ open: true, team, error: '' });
  };

  const handleDeleteConfirm = async () => {
    setDeleteDialog({ ...deleteDialog, error: '' });
    try {
      const result = await deleteATeam(user.id, deleteDialog.team.id);
      if (result.success) {
        setDeleteDialog({ open: false, team: null, error: '' });
        loadTeams();
      } else {
        setDeleteDialog({ ...deleteDialog, error: result.error || 'Fehler beim Löschen.' });
      }
    } catch (err) {
      setDeleteDialog({ ...deleteDialog, error: 'Netzwerkfehler beim Löschen.' });
    }
  };

  // Handler für die Buttons
  const handleShowTeamDashboard = (team) => {
    navigate(`/agenturen/${agenturId}/teams/${team.id}/dashboard`);
  };

  const handleShowMitarbeiter = async (team) => {
    navigate(`/agenturen/${agenturId}/teams/${team.id}/mitarbeiter`);
  };

  const handleShowLeads = async (team) => {
    navigate(`/agenturen/${agenturId}/teams/${team.id}/leads`);
  };

  // Ansicht zurücksetzen
  const handleBackToTeams = () => {
    navigate(`/agenturen/${agenturId}/teams`);
  };

  // Navigation wie in TeamManagement.js
  const handleSectionChange = (section) => {
    if (section === 'dashboard') {
      navigate('/dashboard');
    } else if (section === 'agenturen') {
      navigate('/agenturen');
    }
  };

  console.log("Teams : ", teams)

  if (loading) {
    return <div style={{ textAlign: 'center', color: '#4a5568', padding: 30 }}>Lade Teams...</div>;
  }

  if (error) {
    return <div style={{ color: '#e53e3e', textAlign: 'center', padding: 30 }}>{error}</div>;
  }
  
  return (
    <>
      <DashboardNav
        activeSection="agenturen"
        onSectionChange={handleSectionChange}
        user={user}
      />
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: 20 }}>

          <div className="page-header-wrapper">
              <button className="back-button" onClick={() => navigate("/agenturen")}>
                  ← Zurück
              </button>
              <h2>
                  Agentur-Teams

              </h2>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>f
              <button style={{ background: '#805ad5', color: 'white', border: 'none', borderRadius: 6, padding: '8px 18px', fontWeight: 500, fontSize: 16, cursor: 'pointer' }} onClick={() => setShowCreateDialog(true)}>+ Team erstellen</button>
          </div>

        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(330px, 1fr))', 
          gap: 20,
          maxWidth: '100%'
        }}>
          {teams.length === 0 ? (
            <div style={{ textAlign: 'center', color: '#718096', background: 'white', borderRadius: 12, border: '2px dashed #e2e8f0', padding: 40, gridColumn: '1/-1' }}>
              Noch keine Teams erstellt
            </div>
          ) : (
            teams.map(team => (
              <div key={team.id} style={{ background: 'white', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', border: '1px solid #e2e8f0', padding: 20, minHeight: 120, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', position: 'relative' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                  <div style={{ fontWeight: 600, fontSize: 18, color: '#2d3748' }}>{team.name}</div>
                  <div style={{ display: 'flex', gap: 8, position: 'absolute', top: 12, right: 12 }}>
                    <button style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }} title="Bearbeiten" onClick={() => handleEditClick(team)}><FaCog size={18} color="#805ad5" /></button>
                    <button style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }} title="Löschen" onClick={() => handleDeleteClick(team)}><FaTrash size={18} color="#e53e3e" /></button>
                  </div>
                </div>
                <div style={{ color: '#4a5568', fontSize: 14, marginBottom: 12 }}>{team.beschreibung || <span style={{ color: '#a0aec0' }}>Keine Beschreibung</span>}</div>
                <div style={{ color: '#805ad5', fontWeight: 500, fontSize: 13, marginBottom: 6 }}>Mitglieder: {team.memberCount}</div>
                <div style={{ color: team.active ? '#10b981' : '#ef4444', fontWeight: 500, fontSize: 13 }}>{team.active ? 'Aktiv' : 'Inaktiv'}</div>
                <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                  <button onClick={() => handleShowTeamDashboard(team)} style={{ background: '#4a6de5', color: 'white', border: 'none', borderRadius: 5, padding: '6px 12px', fontWeight: 500, cursor: 'pointer' }}>Team Dashboard</button>
                  <button onClick={() => handleShowMitarbeiter(team)} style={{ background: '#805ad5', color: 'white', border: 'none', borderRadius: 5, padding: '6px 12px', fontWeight: 500, cursor: 'pointer' }}>Mitarbeiter</button>
                  <button onClick={() => handleShowLeads(team)} style={{ background: '#805ad5', color: 'white', border: 'none', borderRadius: 5, padding: '6px 12px', fontWeight: 500, cursor: 'pointer' }}>Leads</button>
                </div>
              </div>
            ))
          )}
        </div>
        {/* Team erstellen Dialog */}
        {showCreateDialog && (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <div style={{ background: 'white', borderRadius: 10, padding: 32, minWidth: 320, maxWidth: '95vw', boxShadow: '0 4px 24px rgba(0,0,0,0.15)' }}>
              <h3 style={{ marginTop: 0, color: '#2d3748' }}>Neues Team erstellen</h3>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Teamname *</label>
                <input type="text" value={newTeam.name} onChange={e => setNewTeam(t => ({ ...t, name: e.target.value }))} style={{ width: '100%', padding: 8, border: '1px solid #cbd5e0', borderRadius: 5, fontSize: 15 }} placeholder="Name des Teams" />
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Beschreibung</label>
                <textarea value={newTeam.beschreibung} onChange={e => setNewTeam(t => ({ ...t, beschreibung: e.target.value }))} style={{ width: '100%', padding: 8, border: '1px solid #cbd5e0', borderRadius: 5, fontSize: 15 }} placeholder="Beschreibung (optional)" rows={3} />
              </div>
              {createError && <div style={{ color: '#e53e3e', marginBottom: 10 }}>{createError}</div>}
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                <button onClick={() => setShowCreateDialog(false)} style={{ padding: '8px 18px', background: '#e2e8f0', color: '#2d3748', border: 'none', borderRadius: 5, fontWeight: 500, fontSize: 15 }}>Abbrechen</button>
                <button onClick={handleCreateTeam} style={{ padding: '8px 18px', background: '#805ad5', color: 'white', border: 'none', borderRadius: 5, fontWeight: 500, fontSize: 15 }}>Erstellen</button>
              </div>
            </div>
          </div>
        )}
        {/* Team bearbeiten Dialog */}
        {editDialog.open && (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <div style={{ background: 'white', borderRadius: 10, padding: 32, minWidth: 320, maxWidth: '95vw', boxShadow: '0 4px 24px rgba(0,0,0,0.15)' }}>
              <h3 style={{ marginTop: 0, color: '#2d3748' }}>Team bearbeiten</h3>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Teamname *</label>
                <input type="text" value={editDialog.name} onChange={e => setEditDialog(d => ({ ...d, name: e.target.value }))} style={{ width: '100%', padding: 8, border: '1px solid #cbd5e0', borderRadius: 5, fontSize: 15 }} placeholder="Name des Teams" />
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Beschreibung</label>
                <textarea value={editDialog.beschreibung} onChange={e => setEditDialog(d => ({ ...d, beschreibung: e.target.value }))} style={{ width: '100%', padding: 8, border: '1px solid #cbd5e0', borderRadius: 5, fontSize: 15 }} placeholder="Beschreibung (optional)" rows={3} />
              </div>
              {editDialog.error && <div style={{ color: '#e53e3e', marginBottom: 10 }}>{editDialog.error}</div>}
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                <button onClick={() => setEditDialog({ open: false, team: null, name: '', beschreibung: '', error: '' })} style={{ padding: '8px 18px', background: '#e2e8f0', color: '#2d3748', border: 'none', borderRadius: 5, fontWeight: 500, fontSize: 15 }}>Abbrechen</button>
                <button onClick={handleEditSave} style={{ padding: '8px 18px', background: '#805ad5', color: 'white', border: 'none', borderRadius: 5, fontWeight: 500, fontSize: 15 }}>Speichern</button>
              </div>
            </div>
          </div>
        )}
        {/* Team löschen Dialog */}
        {deleteDialog.open && (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <div style={{ background: 'white', borderRadius: 10, padding: 32, minWidth: 320, maxWidth: '95vw', boxShadow: '0 4px 24px rgba(0,0,0,0.15)' }}>
              <h3 style={{ marginTop: 0, color: '#e53e3e' }}>Team wirklich löschen?</h3>
              <div style={{ marginBottom: 18, color: '#2d3748' }}>Möchtest du das Team <b>{deleteDialog.team?.name}</b> wirklich löschen?</div>
              {deleteDialog.error && <div style={{ color: '#e53e3e', marginBottom: 10 }}>{deleteDialog.error}</div>}
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                <button onClick={() => setDeleteDialog({ open: false, team: null, error: '' })} style={{ padding: '8px 18px', background: '#e2e8f0', color: '#2d3748', border: 'none', borderRadius: 5, fontWeight: 500, fontSize: 15 }}>Abbrechen</button>
                <button onClick={handleDeleteConfirm} style={{ padding: '8px 18px', background: '#e53e3e', color: 'white', border: 'none', borderRadius: 5, fontWeight: 500, fontSize: 15 }}>Löschen</button>
              </div>
            </div>
          </div>
        )}

          <style jsx>{`
          .page-header-wrapper {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            padding: 20px;
            background: white;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          }

          .page-header-wrapper h2 {
            margin: 0;
            color: #2d3748;
            font-size: 1.5rem;
          }

          .back-button {
            padding: 8px 16px;
            background: #4a6de5;
            color: white;
            border: none;
            border-radius: 6px;
            cursor: pointer;
            font-size: 0.875rem;
            transition: background-color 0.2s;
          }

          .back-button:hover {
            background: #3c5ce0;
          }

          .leads-filters {
            background: white;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            padding: 20px;
            margin-bottom: 20px;
          }

          /* NEUE STYLES FÜR SUCHE */
          .search-row {
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 16px;
            padding: 16px;
            background: #f8fafc;
            border-radius: 8px;
            border: 1px solid #e2e8f0;
          }

          .search-group-flex {
            display: flex;
            flex-direction: row;
            align-items: center;
            min-width: 0;
            flex: 1;
          }

          .search-input-flex {
            display: flex;
            flex-direction: row;
            align-items: center;
            flex: 1;
            min-width: 0;
            gap: 8px;
            max-width: 400px;
            width: 100%;
          }

          .search-input {
            flex: 1 1 0;
            min-width: 0;
            width: auto;
            padding: 10px 12px;
            border: 2px solid #e2e8f0;
            border-radius: 6px;
            font-size: 0.95rem;
            transition: border-color 0.2s, box-shadow 0.2s;
          }

          .search-input:focus {
            outline: none;
            border-color: #4a6de5;
            box-shadow: 0 0 0 3px rgba(74, 109, 229, 0.1);
          }

          .clear-search-button {
            background: none;
            border: none;
            color: #a0aec0;
            cursor: pointer;
            font-size: 1.1rem;
            width: 32px;
            height: 32px;
            min-width: 32px;
            min-height: 32px;
            max-width: 32px;
            max-height: 32px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: background-color 0.2s, color 0.2s;
            margin-left: 0;
          }

          .clear-search-button:hover {
            background-color: #f7fafc;
            color: #e53e3e;
          }

          .search-results-info {
            display: flex;
            align-items: center;
            font-size: 0.875rem;
          }

          .no-results {
            color: #e53e3e;
            font-weight: 500;
          }

          .results-count {
            color: #38a169;
            font-weight: 500;
          }

          .clear-search-suggestion {
            background: #4a6de5;
            color: white;
            border: none;
            padding: 8px 16px;
            border-radius: 6px;
            cursor: pointer;
            font-size: 0.875rem;
            margin-top: 8px;
            transition: background-color 0.2s;
          }

          .clear-search-suggestion:hover {
            background: #3c5ce0;
          }

          /* HIGHLIGHT STYLES */
          .search-highlight {
            background-color: #fff5f5 !important;
          }

          .search-highlight:hover {
            background-color: #fed7d7 !important;
          }

          .name-highlight {
            background-color: #fef3c7;
            padding: 2px 4px;
            border-radius: 3px;
            font-weight: 600;
          }

          /* FILTER STYLES */
          .filter-row {
            display: flex;
            gap: 20px;
            margin-bottom: 16px;
            flex-wrap: wrap;
          }

          .filter-group {
            display: flex;
            flex-direction: column;
            min-width: 150px;
            flex: 1;
          }

          .filter-group label {
            font-size: 0.875rem;
            font-weight: 500;
            color: #4a5568;
            margin-bottom: 6px;
          }

          .filter-group select,
          .filter-group input {
            padding: 8px 12px;
            border: 1px solid #e2e8f0;
            border-radius: 6px;
            font-size: 0.875rem;
            transition: border-color 0.2s;
          }

          .filter-group select:focus,
          .filter-group input:focus {
            outline: none;
            border-color: #4a6de5;
            box-shadow: 0 0 0 3px rgba(74, 109, 229, 0.1);
          }

          .reset-filters-button {
            padding: 8px 16px;
            background-color: #f3f4f6;
            color: #4b5563;
            border: 1px solid #d1d5db;
            border-radius: 6px;
            cursor: pointer;
            font-size: 0.875rem;
            margin-top: 22px;
            transition: all 0.2s;
          }

          .reset-filters-button:hover {
            background-color: #e5e7eb;
            color: #1f2937;
          }

          /* CHECKBOX FILTER STYLES */
          .checkbox-filter {
            display: flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;
            margin-top: 22px;
            padding: 8px 12px;
            border: 1px solid #e2e8f0;
            border-radius: 6px;
            background-color: #f8fafc;
            transition: all 0.2s;
            user-select: none;
          }

          .checkbox-filter:hover {
            background-color: #edf2f7;
            border-color: #cbd5e0;
          }

          .checkbox-input {
            width: 16px;
            height: 16px;
            margin: 0;
            cursor: pointer;
            accent-color: #4a6de5;
          }

          .checkbox-label {
            font-size: 0.875rem;
            font-weight: 500;
            color: #4a5568;
            cursor: pointer;
          }

          .checkbox-filter:has(.checkbox-input:checked) {
            background-color: #ebf4ff;
            border-color: #4a6de5;
          }

          .checkbox-filter:has(.checkbox-input:checked) .checkbox-label {
            color: #4a6de5;
            font-weight: 600;
          }

          /* TABLE STYLES */
          .leads-table {
            width: 100%;
            border-collapse: collapse;
            background: white;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            table-layout: fixed;
          }

          /* Container für die Tabelle mit Scrollbalken */
          .table-container {
            position: relative;
            width: 100%;
            overflow-x: auto;
            overflow-y: auto;
            max-height: calc(100vh - 300px);
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          }

          /* Scrollbalken-Styling */
          .table-container::-webkit-scrollbar {
            height: 12px;
            width: 12px;
          }

          .table-container::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 6px;
          }

          .table-container::-webkit-scrollbar-thumb {
            background: #cbd5e0;
            border-radius: 6px;
          }

          .table-container::-webkit-scrollbar-thumb:hover {
            background: #a0aec0;
          }

          /* Header für bessere Lesbarkeit beim Scrollen */
          .leads-table thead {
            position: sticky;
            top: 0;
            z-index: 1;
          }

          .leads-table thead th {
            position: sticky;
            top: 0;
            background: #f7fafc;
            z-index: 2;
          }

          .leads-table th {
            background: #f7fafc;
            padding: 8px 12px;
            text-align: left;
            font-weight: 600;
            color: #4a5568;
            border-bottom: 1px solid #e2e8f0;
            font-size: 0.75rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .leads-table td {
            padding: 8px 12px;
            border-bottom: 1px solid #e2e8f0;
            vertical-align: middle;
            font-size: 0.75rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          /* PRODUCT BADGES */
          .product-badges {
            display: flex;
            gap: 4px;
          }

          .product-badge {
            display: inline-block;
            padding: 0.2rem 0.5rem;
            border-radius: 0.25rem;
            font-size: 0.7rem;
            font-weight: 700;
            text-align: center;
          }

          .pv-badge {
            background-color: #c3dafe;
            color: #4a6de5;
          }

          .wp-badge {
            background-color: #b2f5ea;
            color: #3182ce;
          }

          /* STATUS BADGES */
          .status-badge {
            display: inline-block;
            padding: 0.25rem 0.5rem;
            border-radius: 0.375rem;
            font-size: 0.75rem;
            font-weight: 500;
            text-align: center;
            white-space: nowrap;
          }

          .status-new {
            background-color: #ebf8ff;
            color: #3182ce;
          }

          .status-in-progress {
            background-color: #fefcbf;
            color: #d69e2e;
          }

          .status-completed {
            background-color: #c6f6d5;
            color: #38a169;
          }

          .status-cancelled {
            background-color: #fed7d7;
            color: #e53e3e;
          }

          /* UTILITY STYLES */
          .loading {
            text-align: center;
            padding: 40px;
            color: #718096;
            font-size: 1rem;
          }

          .no-data {
            text-align: center;
            padding: 40px;
            color: #a0aec0;
            font-size: 1rem;
          }

          /* RESPONSIVE DESIGN */
          @media (max-width: 768px) {
            .search-row {
              flex-direction: column;
              gap: 12px;
            }

            .search-group-flex {
              min-width: auto;
            }

            .filter-row {
              flex-direction: column;
              gap: 12px;
            }

            .filter-group {
              min-width: auto;
            }

            .leads-table {
              font-size: 0.8rem;
            }

            .leads-table th,
            .leads-table td {
              padding: 8px 6px;
            }
          }

          /* ACCESSIBILITY */
          .search-input:focus,
          .filter-group select:focus,
          .filter-group input:focus {
            outline: none;
            border-color: #4a6de5;
            box-shadow: 0 0 0 3px rgba(74, 109, 229, 0.1);
          }

          .reset-filters-button:focus,
          .clear-search-button:focus,
          .clear-search-suggestion:focus {
            outline: 2px solid #4a6de5;
            outline-offset: 2px;
          }
        `}</style>

      </div>
    </>
  );
}

export default AgenturTeams; 